import Web3 from "web3";
import { CHAINS, PROJECT_ID } from "../Config/env";
import { getAccount } from "./useAccount";
import toast, { Toaster } from "react-hot-toast";
import { sleep } from "./UseContract";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import {
  AAVE_ABI,
  AAVE_ARBITRAGE,
  ARBITRAGE,
  ARBITRAGE_ABI,
} from "../Config/arbitrage";
import config from "../Config/index";

import { AddTransaction } from "../actions/markets";
import { ERC20_ABI } from "../Config/erc20";
export const useWeb3 = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);

  let web3;

  if (localStorage.getItem("wcv2") != null) {
    const provider = await EthereumProvider.init({
      projectId: PROJECT_ID, // required
      chains: [CHAIN_ID], // required
      showQrModal: true, // requires @walletconnect/modal
    });
    await provider.enable();
    web3 = new Web3(provider);
  } else if (typeof window.BinanceChain !== "undefined") {
    web3 = new Web3(window.BinanceChain);
    // return web3;
  } else if (sessionStorage.getItem("accountInfo") != null) {
    web3 = new Web3(window.ethereum);
    //   return web3;
  } else {
    web3 = new Web3(httpProvider);
    //   return web3;
  }
  const chainIds = await web3.eth.getChainId();
  if (parseInt(chainIds) != parseInt(CHAIN_ID)) {
    const data = await SwitchChain();
    if (data) {
      // window.location.reload();
    }
  }

  return web3;
};

export const usehttpProvider = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  console.log("RPC_URLRPC_URL", RPC_URL);
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);

  let web3;

  web3 = new Web3(httpProvider);

  const chainIds = await web3.eth.getChainId();
  console.log("chainIds_chainIds_V", chainIds);
  if (parseInt(chainIds) != parseInt(CHAIN_ID)) {
    const data = await SwitchChain();
    if (data) {
      window.location.reload();
    }
  }

  return web3;
};

export const UseProvider = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  var provider = window.BinanceChain;

  if (localStorage.getItem("wcv2") != null) {
    const provider = await EthereumProvider.init({
      projectId: PROJECT_ID, // required
      chains: [CHAIN_ID], // required
      showQrModal: true, // requires @walletconnect/modal
    });
    await provider.enable();

    return provider;
  } else if (typeof window.BinanceChain !== "undefined") {
    return window.BinanceChain;
  } else if (sessionStorage.getItem("accountInfo") != null) {
    return window.ethereum;
  }
};

export const CURRENT_RPC_URL = () => {
  const index = GetChainIndex();
  console.log("====================================");
  console.log("CURRENT_RPC_URL", index);
  console.log("====================================");
  return CHAINS[index].RPC_URL;
};

export const GetChainIndex = () => {
  return localStorage.getItem("CHAIN") ? localStorage.getItem("CHAIN") : "0";
};

export const CURRENT_CHAIN_ID = () => {
  const index = GetChainIndex();
  // console.log("index>>>>", index);
  return CHAINS[index].CHAIN_ID;
};

export const SwitchChain = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  // Check if MetaMask is installed
  // MetaMask injects the global API into window.ethereum
  const hexString = CHAIN_ID.toString(16);
  if (window.ethereum) {
    try {
      // check if the chain to connect to is installed

      const data = window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
      });
      await toast.promise(
        data,
        {
          loading: "Switching Network ...",
          success: "Network Switched Successfully",
          error: "Error ! When Switching Network",
        },
        {
          style: {
            minWidth: "300px",
            minHeight: "55px",
          },
        },
        await sleep(1000)
      );
      return true;
    } catch (error) {
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          const data = window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x" + hexString,
                rpcUrl: RPC_URL,
              },
            ],
          });
          await toast.promise(
            data,
            {
              loading: "Switching Network ...",
              success: "Network Switched Successfully",
              error: "Error ! When Switching Network",
            },
            {
              style: {
                minWidth: "300px",
                minHeight: "55px",
              },
            }
          );
          return true;
        } catch (addError) {
          console.error(addError);
          toast.error(`Error : ${addError}`, {
            style: {
              minWidth: "300px",
              minHeight: "55px",
            },
          });
        }
      }
      console.error(error);
    }
  } else {
    // if no window.ethereum then MetaMask is not installed

    return false;
  }
};

export const SwitchChainS = async (i) => {
  const RPC_URL = CHAINS[i].RPC_URL;
  const CHAIN_ID = CHAINS[i].CHAIN_ID;
  // Check if MetaMask is installed
  // MetaMask injects the global API into window.ethereum
  const hexString = CHAIN_ID.toString(16);
  if (window.ethereum) {
    try {
      // check if the chain to connect to is installed

      const data = window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
      });
      console.log("Switching_Network3");
      await toast.promise(
        data,
        {
          loading: "Switching Network ...",
          success: "Network Switched Successfully",
          error: "Error ! When Switching Network",
        },
        {
          style: {
            minWidth: "300px",
            minHeight: "55px",
          },
        }
        // await sleep(1000)
      );
      return true;
    } catch (error) {
      console.log("errrrrrrrror", error);
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          const data = window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x" + hexString,
                rpcUrl: RPC_URL,
              },
            ],
          });
          console.log("Switching_Network4");
          await toast.promise(
            data,
            {
              loading: "Switching Network ...",
              success: "Network Switched Successfully",
              error: "Error ! When Switching Network",
            },
            {
              style: {
                minWidth: "300px",
                minHeight: "55px",
              },
            }
          );
          return true;
        } catch (addError) {
          console.error(addError);
          toast.error(`Error : ${addError}`, {
            style: {
              minWidth: "300px",
              minHeight: "55px",
            },
          });
        }
      }
      console.error(error);
    }
  } else {
    // if no window.ethereum then MetaMask is not installed

    return false;
  }
};

export const setChainId = async (i) => {
  try {
    localStorage.setItem("CHAIN", i);
  } catch (err) {
    console.log("setChainId_err", err);
  }
};

export const toFixedNumber = (x) => {
  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split("e-")[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = "0." + new Array(e).join("0") + x.toString().substring(2);
    }
  } else {
    var e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x.toString();
};

export const UseSchedulePay = async ({
  loanPool,
  loanAmounts,
  tokenPath,
  amounts,
  routing,
  routers,
  pairs,
}) => {
  const web3 = await useWeb3();
  const gasPrice = await web3.eth.getGasPrice();
  const user = getAccount();
  // debugger
  // const data =
  // contractFlashLoan.methods.flashloan(
  //   loanPool,
  //   loanAmounts,
  //   tokenPath,
  //   amounts,
  //   routing,
  //   routers,
  //   pairs
  // ).encodeABI();

  // const gasLimit = await web3.eth.estimateGas({
  //   from: user,
  //   to:ARBITRAGE,
  //   data: data,
  // });
  const admin = config.ADMIN_WALLET;
  const gasLimit = 163587;
  console.log("gasLimit : ", parseFloat(gasLimit) * parseFloat(gasPrice));
  const balance = await web3.eth.getBlockNumber();
  console.log("Balanmce : ", user, admin, balance);

  const send = await web3.eth.sendTransaction({
    from: user,
    to: admin,
    value: parseFloat(gasLimit) * parseFloat(gasPrice),
    gas: gasPrice,
    gasLimit: gasLimit,
  });

  return parseFloat(gasLimit) * parseFloat(gasPrice);
};

export const UseTriggerArbitrage = async ({
  loanPool,
  loanAmounts,
  tokenPath,
  amounts,
  routing,
  routers,
  pairs,
}) => {
  console.log(
    loanPool,
    "loanPool",
    loanAmounts,
    "loanAmounts",
    tokenPath,
    "tokenPath",
    amounts,
    "amounts",
    routing,
    "routing",
    routers,
    "routers",
    pairs,
    "pairs"
  );
  const web3 = await useWeb3();
  const gasPrice = await web3.eth.getGasPrice();
  const user = getAccount();
  const contractFlashLoan = new web3.eth.Contract(ARBITRAGE_ABI, ARBITRAGE);

  const data = contractFlashLoan.methods
    .flashloan(
      loanPool,
      loanAmounts,
      tokenPath,
      amounts,
      routing,
      routers,
      pairs
    )
    .encodeABI();

  const gasLimit = await web3.eth.estimateGas({
    from: user,
    to: ARBITRAGE,
    data: data,
  });
  const txFlashloan = await contractFlashLoan.methods
    .flashloan(
      loanPool,
      loanAmounts,
      tokenPath,
      amounts,
      routing,
      routers,
      pairs
    )
    .send({ from: user, gasPrice: gasPrice, gasLimit: gasLimit });

  //

  // let { status, message, result } = await AddTransaction({
  //   transactionHash: txFlashloan.hash,
  //   address: getAccount(),
  //   token0: _tokenIn,
  //   token1: _tokenOut,
  //   symbol: "",
  //   prices: _amount,
  //   difference: "",
  //   gains: "",
  //   trade: [],
  // });
  return txFlashloan;
};

export const UseTriggerArbitragePoly = async ({
  _tokenIn, _tokenOut, _amount, router1, router2,
  routing, pairs
}) => {
  // if (!canDeploy) return console.error(`Can Depoly is set to false !`);
  const web3 = await useWeb3();
  const gasPrice = await web3.eth.getGasPrice();
  const user = getAccount();
  console.log("User execute 1 : ", user);
  const contractFlashLoan = new web3.eth.Contract(AAVE_ABI, AAVE_ARBITRAGE);
  console.log("User execute : ", user);
  console.log(".flashloan", _tokenIn, _tokenOut, _amount, router1, routing, router2, pairs);
  const data = contractFlashLoan.methods
    .requestFlashLoan(_tokenIn, _amount, _tokenOut, router1, routing, router2, pairs)
    .encodeABI();

  const gasLimit = await web3.eth.estimateGas({
    from: user,
    to: AAVE_ARBITRAGE,
    data: data,
  });
  const txFlashloan = await contractFlashLoan.methods
    .requestFlashLoan(_tokenIn, _amount, _tokenOut, router1, routing, router2, pairs)
    .send({
      from: user,
      gasPrice: parseFloat(gasPrice),
      gasLimit: parseFloat(gasLimit),
    });

  // let { status, message, result } = await AddTransaction({
  //   transactionHash: txFlashloan.hash,
  //   address: getAccount(),
  //   token0: _tokenIn,
  //   token1: _tokenOut,
  //   symbol: "",
  //   prices: _amount,
  //   difference: "",
  //   gains: "",
  //   trade: [],
  // });

  return txFlashloan;
};


export const UserBalance = async (address) => {
  try {

    // let provider1 = CHAINS[0].RPC_URL
    let provider2 = CHAINS[0].RPC_URL

    // const web31 = new Web3(provider1);
    const web32 = new Web3(provider2);

    // let balance1 = await web31.eth.getBalance(address)
    let balance2 = await web32.eth.getBalance(address)

    return {
      // balance1: Number(balance1) / 10 ** 18,
      balance1: 0,

      balance2: Number(balance2) / 10 ** 18,
    }

  }
  catch (err) {
    console.log(err)
  }

}

// older version Wallet connect v1

// if(localStorage.getItem("walletconnect")!=null){
//   const provider = await EthereumProvider.init({
//     projectId:'b8a1daa2dd22335a2fe1d2e139980ae0',
//     chains: [56],
//     showQrModal:true,
//     methods: [
//       "eth_sendTransaction",
//       "eth_signTransaction",
//       "eth_sign",
//       "personal_sign",
//       "eth_signTypedData",
//       "eth_requestAccounts"
//     ],
//     events: ["chainChanged", "accountsChanged"]
//   })

//   const session = await provider.connect({
//     namespaces: {
//       eip155: {
//         methods: [
//           "eth_sendTransaction",
//           "eth_signTransaction",
//           "eth_sign",
//           "personal_sign",
//           "eth_signTypedData",
//           "eth_requestAccounts"
//         ],
//         chains: [`eip155:56`],
//         events: ["chainChanged", "accountsChanged"],
//         rpcMap: {},
//       },
//     },
//   });

//   // await provider.enable();
//   console.log("provider",provider)
//   web3 = new Web3(provider);

// //  return web3;
// }
